//  Immediately Invoked Function Expression to keep the javascript Scope contained
(function() {
    angular
        .module('app')
        .factory('dateParser', dateParser);

    // This directive makes the model of the file marked for upload accessible
    function dateParser() {
        var dateParser = this;
        dateParser.parseDate = parseDate;

        function parseDate(string, seconds){
            if(typeof string !== 'string' || !string) return undefined;
            if(!seconds) seconds = 0;

            var a = string.split(/[^0-9]/);
            var d = new Date (a[0],a[1]-1,a[2],a[3],a[4],seconds);
            return d;
        }

        return dateParser;
    }
})();